export default __webpack_public_path__ + "static/media/movieBackAlt.80f8e818.svg";